var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-control',{staticClass:"mouse-coords"},[_c('p',[_vm._v(" Lat: "+_vm._s(_vm.coords[0])+" "),_c('br'),_vm._v(" Lng: "+_vm._s(_vm.coords[1])+" "),_c('br'),_vm._v(" Zoom: "+_vm._s(_vm.mapZoom)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }